import React from "react";

const NoticeIconNew = ({ width, height, fill, style, onClick }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 26 25"
      fill="none"
      style={style}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7734 18.75H13.6484V11.25H11.7734V18.75ZM12.6166 8.9375C12.9087 8.9375 13.1536 8.84167 13.3516 8.65C13.5495 8.45833 13.6484 8.22083 13.6484 7.9375C13.6484 7.63646 13.5497 7.38412 13.3521 7.18047C13.1546 6.97682 12.9098 6.875 12.6178 6.875C12.3257 6.875 12.0807 6.97682 11.8828 7.18047C11.6849 7.38412 11.5859 7.63646 11.5859 7.9375C11.5859 8.22083 11.6847 8.45833 11.8822 8.65C12.0798 8.84167 12.3246 8.9375 12.6166 8.9375ZM12.6255 25C10.9019 25 9.28208 24.6719 7.76612 24.0156C6.25017 23.3594 4.92448 22.4635 3.78906 21.3281C2.65365 20.1927 1.75781 18.8662 1.10156 17.3487C0.445312 15.8312 0.117188 14.2098 0.117188 12.4844C0.117188 10.759 0.445312 9.13753 1.10156 7.62003C1.75781 6.10251 2.65365 4.78125 3.78906 3.65625C4.92448 2.53125 6.25095 1.64062 7.76847 0.984375C9.28597 0.328125 10.9074 0 12.6328 0C14.3582 0 15.9797 0.328125 17.4972 0.984375C19.0147 1.64062 20.3359 2.53125 21.4609 3.65625C22.5859 4.78125 23.4766 6.10417 24.1328 7.625C24.7891 9.14583 25.1172 10.7681 25.1172 12.4917C25.1172 14.2153 24.7891 15.8351 24.1328 17.3511C23.4766 18.867 22.5859 20.1908 21.4609 21.3224C20.3359 22.454 19.013 23.3498 17.4922 24.0099C15.9714 24.67 14.3491 25 12.6255 25ZM12.6328 23.125C15.5807 23.125 18.0859 22.0885 20.1484 20.0156C22.2109 17.9427 23.2422 15.4323 23.2422 12.4844C23.2422 9.53646 22.2129 7.03125 20.1543 4.96875C18.0957 2.90625 15.5833 1.875 12.6172 1.875C9.67969 1.875 7.17448 2.90429 5.10156 4.96288C3.02865 7.02148 1.99219 9.53385 1.99219 12.5C1.99219 15.4375 3.02865 17.9427 5.10156 20.0156C7.17448 22.0885 9.6849 23.125 12.6328 23.125Z"
        fill={fill}
      />
    </svg>
  );
};

NoticeIconNew.defaultProps = {
  width: 26,
  height: 25,
  fill: "black",
};

export default NoticeIconNew;
